import HttpService from './http.service';
import SessionService from './session.service';

export default abstract class BaseService {
  protected httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get apiUrl(): string {
    if (import.meta.env.PROD) {
      return '/api';
    }
    return import.meta.env.VITE_API_URL || '';
  }

  get sessionService(): typeof SessionService {
    return SessionService;
  }
}
